export const UserType = {
    GET_USER: 'GET_USER'
  };